import { get, post } from '@/utils/apiBase.js';
// 账户列表
const getShroffList = (option) => {
    return get('/apis/useraccount/list', option)
}
// 银行列表
const getBankList = (option) => {
    return get('/apis/useraccount/bank_list', option)
}
// 创建账户
export const createShroff = (option) => {
    return post('/apis/useraccount/create', option);
};
// （短信验证）发送短信
export const sendVcode = (option) => {
    return post('/apis/useraccount/obtain/sms_code', option);
};
// （短信验证）验证
export const postSmsCheck = (option) => {
    return post('/apis/useraccount/sms_check', option);
};
// （小额支付验证）小额支付
export const postMallPaymeny = (option) => {
    return post('/apis/useraccount/obtain/mall_paymeny', option);
};
// （小额支付验证）验证
export const smallPaymentCheck = (option) => {
    return post('/apis/useraccount/small_payment_check', option);
};
// 查询卡号（复制）
const getBankCard = (option) => {
    return get('/apis/useraccount/query/bank_card', option)
}
// 查询用户开票信息
const getInvoicInfo = (option) => {
    return get('/apis/userauth/query/invoic_info', option)
}
// 通过用户ID查询可用银行卡号
const getPassList = (option) => {
    return get('/apis/useraccount/query/pass_list', option)
}
// 验证用户是否可以创建收款账号
const checkCreateAccount = (option) => {
    return get('/apis/userauth/check/create_account', option)
}
export default {
    getShroffList,
    getBankList,
    createShroff,
    sendVcode,
    postSmsCheck,
    postMallPaymeny,
    getBankCard,
    smallPaymentCheck,
    getInvoicInfo,
    getPassList,
    checkCreateAccount
};